import businessMenu from "./menu-item-internal/business-menu";
import operationalMenu from "./menu-item-internal/operational-menu";
import financialMenu from "./menu-item-internal/financial-menu";
import riskManagementMenu from "./menu-item-internal/risk-management-menu";
import relationshipMenu from "./menu-item-internal/relationship-menu";
import administrationMenu from "./menu-item-internal/administration-menu";
import internalRegistryMenu from "./menu-item-internal/internal-registry-menu";
import configurationMenu from "./menu-item-internal/configuration-menu";

export default [
  {
    label: "Negócios",
    icon: "fas fa-briefcase",
    items: businessMenu
  },
  {
    label: "Operacional",
    icon: "fas fa-dollar-sign",
    items: operationalMenu
  },
  {
    label: "Financeiro",
    icon: "fas fa-dollar-sign",
    items: financialMenu
  },
  {
    label: "Gestão de Riscos",
    icon: "fas fa-chalkboard-teacher",
    items: riskManagementMenu
  },
  {
    label: "Relacionamento",
    icon: "fas fa-heart",
    items: relationshipMenu
  },
  {
    label: "Administração",
    icon: "fas fa-list",
    items: administrationMenu
  },
  {
    label: "Cadastros internos",
    icon: "fas fa-cog",
    items: internalRegistryMenu
  },
  {
    label: "Configuração",
    icon: "fas fa-cog",
    items: configurationMenu
  }
];


// WEBPACK FOOTER //
// ./src/data/header-nav-items-recursive.js